import { render, staticRenderFns } from "./DocumentsEnlargeGraph.vue?vue&type=template&id=528a0082"
import script from "./DocumentsEnlargeGraph.vue?vue&type=script&lang=js"
export * from "./DocumentsEnlargeGraph.vue?vue&type=script&lang=js"
import style0 from "./DocumentsEnlargeGraph.vue?vue&type=style&index=0&id=528a0082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports